import { use, useId, type ReactNode } from 'react'

import { FieldLabelContext } from '@/shared/ui'
import { FieldError } from '@/shared/ui/FieldError'

/**
 * A group the row names, such as a chooser, focusable so a failed save can take focus to it, with
 * its error under it. Pass `errorId` when the fields inside also name the error. Groups that share
 * one error pass the same `errorId`, and all but one set `showsError` false: each is still marked
 * and named by the one message.
 */
export function FieldGroup(props: {
  readonly error: string | undefined
  readonly errorId?: string
  readonly showsError?: boolean
  readonly children: ReactNode
}) {
  const ownErrorId = useId()
  const errorId = props.errorId ?? ownErrorId
  const labelId = use(FieldLabelContext)
  return (
    <fieldset
      tabIndex={-1}
      {...(labelId === null ? {} : { 'aria-labelledby': labelId })}
      {...(props.error === undefined ? {} : { 'aria-invalid': true, 'aria-describedby': errorId })}
      className="flex flex-col gap-1 rounded-xs"
    >
      {props.children}
      {props.error !== undefined && props.showsError !== false && <FieldError id={errorId} message={props.error} />}
    </fieldset>
  )
}
